<template>
  <div class="info2-page">
    <div class="info2-content">
      <div class="page-heading">
        <div>
          <h2>我的信息</h2>
          <p>查看账户资料、余额、会员权益和充值记录</p>
        </div>
        <app-icon  class="app-icon" name="manage_accounts"></app-icon>
      </div>

      <div class="summary-grid">
        <section class="profile-card">
          <div class="avatar"><app-icon  class="app-icon" name="person"></app-icon></div>
          <div class="profile-main">
            <small>当前账号</small>
            <strong>{{ currentAccount }}</strong>
            <span>已登录账户</span>
          </div>
        </section>

        <section class="balance-card">
          <div class="card-icon"><app-icon  class="app-icon" name="account_balance_wallet"></app-icon></div>
          <div><small>账户余额</small><strong>¥{{ balance || 0 }}</strong></div>
        </section>

        <section class="security-card">
          <div class="card-icon"><app-icon  class="app-icon" name="lock_reset"></app-icon></div>
          <div><small>账户安全</small><strong>修改密码</strong></div>
          <el-button size="mini" plain @click="$router.push('/password')">前往修改</el-button>
        </section>
      </div>

      <section class="panel vip-panel">
        <div class="panel-header">
          <div><h3>我的会员</h3><p>查看当前会员有效期和剩余权益</p></div>
          <el-button size="small" type="primary" plain @click="$router.push('/user2/vip')">购买会员</el-button>
        </div>
        <div class="vip-scroll-wrap">
          <div class="vip-container" ref="vipScroll" @scroll="updateVipScroll">
            <User_vip ref="user_vip"></User_vip>
          </div>
          <div v-if="vipScrollable" class="vip-fade"></div>
        </div>
      </section>

      <section class="panel order-panel">
        <div class="panel-header">
          <div><h3>充值记录</h3><p>查看账户历史充值明细</p></div>
          <span class="order-count">共 {{ total }} 条</span>
        </div>
        <el-table class="desktop-orders" :data="orderData" size="small" empty-text="暂无充值记录"
          :header-cell-style="{ background: '#f8fafc', color: '#64748b', fontWeight: 500 }">
          <el-table-column prop="order_no" label="订单号" min-width="180"></el-table-column>
          <el-table-column prop="amount" label="金额(元)" width="140">
            <template slot-scope="scope"><strong class="money">¥{{ scope.row.amount }}</strong></template>
          </el-table-column>
          <el-table-column prop="created_at" label="日期" min-width="170" :formatter="formatDate"></el-table-column>
        </el-table>
        <div class="mobile-orders">
          <article v-for="order in orderData" :key="order.order_no" class="order-card"><div><strong>¥{{ order.amount }}</strong><time>{{ formatDate(order) }}</time></div><p>订单号 {{ order.order_no }}</p></article>
          <div v-if="!orderData.length" class="order-empty">暂无充值记录</div>
        </div>
        <el-pagination v-if="total > 5" small background layout="prev, pager, next" :page-size="5" :total="total"
          :current-page="page" @current-change="fy_page"></el-pagination>
      </section>
    </div>
  </div>
</template>

<script>
import User_vip from './UserVip.vue'
import { getUserProfile } from '@/config/userProfile'

export default {
  name: 'User2Info',
  components: { User_vip },
  data() {
    return { username: '', phone: '', balance: 0, orderData: [], total: 0, page: 1, vipScrollable: false }
  },
  computed: {
    currentAccount() {
      const phone = String(this.phone || '').trim()
      return phone && !/^\*+$/.test(phone) ? phone : (this.username || '—')
    }
  },
  methods: {
    formatDate(row) {
      const timestamp = Number(row.created_at || 0)
      if (!timestamp) return '—'
      const date = new Date(timestamp * 1000)
      const pad = value => String(value).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },
    fy_page(page) {
      this.page = page
      this.order()
    },
    order() {
      return this.$ajax.get(`api/v1/users/orders?page=${this.page}&page_size=5`).then(res => {
        const body = res.data || {}
        if (body.status !== 200) throw new Error(body.msg || '获取充值记录失败')
        const data = body.data || {}
        this.orderData = data.items || []
        this.total = data.total || 0
      }).catch(err => {
        console.error(err)
        this.$msg.error('获取充值记录失败')
      })
    },
    updateVipScroll() {
      const el = this.$refs.vipScroll
      if (!el) {
        this.vipScrollable = false
        return
      }
      this.vipScrollable =
        el.scrollHeight > el.clientHeight + 4 &&
        el.scrollTop < el.scrollHeight - el.clientHeight - 4
    },
    info(type = '') {
      if (type !== '') {
        this.$msg.warning('请前往手机APP修改密码')
        return
      }
      getUserProfile(this.$ajax).then(data => {
        if (data) {
          this.phone = data.phone
          this.username = data.username
          this.balance = data.balance
        }
      }).catch(err => {
        console.error(err)
        this.$msg.error('获取用户信息失败')
      })
    }
  },
  created() {
    this.info()
    this.order()
  },
  mounted() {
    this.$refs.user_vip.get_vip_list()
    this.$nextTick(() => this.updateVipScroll())
    if (this.$refs.vipScroll && typeof MutationObserver !== 'undefined') {
      this._vipObserver = new MutationObserver(() => this.updateVipScroll())
      this._vipObserver.observe(this.$refs.vipScroll, { childList: true, subtree: true })
    }
    this._onVipResize = () => this.updateVipScroll()
    window.addEventListener('resize', this._onVipResize)
  },
  beforeDestroy() {
    if (this._vipObserver) this._vipObserver.disconnect()
    if (this._onVipResize) window.removeEventListener('resize', this._onVipResize)
  }
}
</script>

<style scoped>
.info2-page { min-height: 100%; padding: 24px 24px 48px; background: #f5f7fa; box-sizing: border-box; }
.info2-content { max-width: 1180px; margin: 0 auto; padding-bottom: 48px; }
.page-heading { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.page-heading h2 { margin: 0 0 6px; color: #1e293b; font-size: 22px; }
.page-heading p { margin: 0; color: #94a3b8; font-size: 13px; }
.page-heading > span { padding: 11px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; font-size: 28px; }
.summary-grid { display: grid; grid-template-columns: 1.2fr .8fr 1fr; gap: 16px; margin-bottom: 18px; }
.profile-card, .balance-card, .security-card { display: flex; align-items: center; gap: 14px; min-height: 92px; padding: 18px 20px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-sizing: border-box; }
.avatar, .card-icon { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 44px; height: 44px; border-radius: 12px; background: #e8f1fe; color: #1a73e8; }
.avatar span { font-size: 27px; }
.profile-main, .balance-card > div:last-child, .security-card > div:nth-child(2) { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.summary-grid small { color: #94a3b8; font-size: 12px; }
.summary-grid strong { color: #1e293b; font-size: 17px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.profile-main span { color: #94a3b8; font-size: 11px; }
.balance-card strong { font-size: 22px; }
.security-card .el-button { margin-left: auto; }
.panel { padding: 22px; border: 1px solid #e2e8f0; border-radius: 12px; background: #fff; box-shadow: 0 4px 16px rgba(15,23,42,.04); }
.panel + .panel { margin-top: 18px; }
.panel-header { display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 18px; }
.panel-header h3 { margin: 0 0 5px; color: #1e293b; font-size: 16px; }
.panel-header p { margin: 0; color: #94a3b8; font-size: 12px; }
.vip-scroll-wrap { position: relative; }
.vip-container { max-height: 280px; overflow-y: auto; }
.vip-fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  background: linear-gradient(to top, rgba(15, 23, 42, 0.12), rgba(15, 23, 42, 0));
  pointer-events: none;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.order-count { color: #94a3b8; font-size: 12px; }
.money { color: #1e293b; font-weight: 600; }
.order-panel /deep/ .el-pagination { margin-top: 20px; text-align: right; }
@media (max-width: 900px) { .summary-grid { grid-template-columns: 1fr 1fr; } .profile-card { grid-column: 1 / -1; } }
@media (max-width: 600px) { .info2-page { padding: 14px 14px 32px; } .info2-content { padding-bottom: 32px; } .summary-grid { grid-template-columns: 1fr; } .profile-card { grid-column: auto; } .panel { padding: 16px; } .security-card .el-button { padding: 7px 10px; } }

.mobile-orders { display:none; }
.order-card { padding:14px 0; border-bottom:1px solid #e2e8f0; }
.order-card>div { display:flex; justify-content:space-between; align-items:center; gap:12px; }
.order-card strong { color:#2563eb; font-size:20px; }
.order-card time { color:#64748b; font-size:12px; }
.order-card p { color:#94a3b8; font-size:11px; overflow-wrap:anywhere; margin:8px 0 0; }
.order-empty { text-align:center; color:#94a3b8; padding:24px; }
@media(max-width:768px) { .desktop-orders { display:none; } .mobile-orders { display:block; } .vip-container { max-height:none; overflow:visible; } .vip-fade { display:none; } }

</style>



// WEBPACK FOOTER //
// src/components/User2/Info.vue